import { request } from '/@/axios/request'
export function editUserInfo(params, options) {
  return request('/customer/user/editUserInfo', params, options, 'post')
}
export function editPassword(params, options) {
  return request('/customer/user/editPassword', params, options, 'post')
}
export function login(params, options) {
  return request('/customer/user/login', params, options, 'post')
}
export function register(params, options) {
  return request('/customer/user/register', params, options, 'post')
}
export function getUserInfo(params, options) {
  return request('/customer/user/getUserInfo', params, options, 'get')
}
export function getPermissions(params, options) {
  return request('/customer/user/getPermissions', params, options, 'post')
}
export function resetPassword(params, options) {
  return request('/customer/user/resetPassword', params, options, 'post')
}
export function bindPhone(params, options) {
  return request('/customer/user/bindPhone', params, options, 'post')
}
export function unBindPhone(params, options) {
  return request('/customer/user/unBindPhone', params, options, 'post')
}

// 获取用户主题
export function getUserTheme(params, options) {
  return request('/customer/user/getUserTheme', params, options, 'get')
}
